import useLeftMenu from "hooks/useLeftMenu"
import type React from "react"
import MenuItem from "./MenuItem"
import styles from "./Sidebar.module.css"

interface MenuChild {
  labelKey: string
  icon: string
  route: string
  external: boolean
}

interface MenuItemType extends MenuChild {
  children?: MenuChild[]
}

const Sidebar: React.FC = () => {
  const menus: MenuItemType[] = useLeftMenu()

  return (
    <div className={styles.Root}>
      {menus.map((menu) => (
        <MenuItem
          key={menu.labelKey}
          route={menu.route}
          icon={menu.icon}
          labelKey={menu.labelKey}
          external={menu.external}
          children={menu.children}
        />
      ))}
    </div>
  )
}

export default Sidebar
